import request from '@/shared/api/request';

export const deleteProject = (uuid: string): Promise<void> =>
  request({
    url: `/projects/${uuid}/`,
    method: 'DELETE',
  });
